module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Mark of Evil ")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "p0027-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#nc5",
      "id": "cn5"
    }
  }, [_c('b', [_vm._v("FIVE ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_c('b', [_vm._v("NEW BABYLON, IRAQ ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Alexander Colliquin, chancellor of the two-year-old Global Alliance of Nations, left his office on the top floor of his twenty-thousand-square-foot “Hanging Gardens” suite. At his side walked stone-faced Ho Zhu, his deputy chancellor. The men were flanked by a squad of security guards. In his breathless, long-legged pace, Colliquin strode ahead of them on the moving walkway, making his way over to the adjoining white stone headquarters of Global Internet Connectivity.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A private, heavily guarded corridor led directly from Colliquin’s office to the IC building, part of the new massive complex of buildings that took up one hundred square miles—land that had been deeded to Colliquin years ago by the United States when his friend "), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v(" Jessica Tulrude, the former U.S. vice president, was finishing out the term of critically ill President Virgil Corland.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Now Colliquin stopped at the bulletproof, triple-layered glass door leading into the IC center. He placed his right eye in the pupil recognition socket and placed his index finger and thumb on the fingerprint ID pad. A laser beam scanned his Romanesque facial features—the kind of face you might expect to see on the cover of "), _c('i', [_vm._v("GQ")]), _vm._v(" magazine—and then electronically outlined his tall, athletic profile from head to foot.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A digital voice spoke from the security console. “Thank you for your cooperation, Chancellor. Have a nice day.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The airlock hissed as the thick glass door opened, followed by another, and another, until Colliquin reached the lobby of the IC facility where the chief of digital imagery, dressed in a light-blue lab coat, waited for him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The guards held back at the entrance of the glass doors. Ho Zhu went through the same security clearance process, and when the airlocks opened for him too, he joined his boss in the lobby. The lab chief led them to an open testing space the size of two football fields. A hundred cubicles were filled with a hundred data engineers, digital architects, network specialists, and electronic image designers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As the chief strolled with the two men through the maze of cubicles, he described the progress to date. “We’re approaching completion of the first phase. At this stage all we have is just a great deal of computer code and schematics and the single prototype system here in this facility. But we are quickly nearing completion.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Colliquin smiled. “The world is about to become a better place. And you, Chief, can be part of this historic evolution.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("The chief smiled. “Yet,” he replied, “the problem still remains. We need a central data hub with enough computing power, speed, memory, storage capacity, and network reach to serve as the nerve center for the kind of global transmissions you are proposing. And no such ")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v(" data center—at least none within the jurisdiction of the ten-nation global alliance—currently exists.”")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Colliquin nodded toward Ho Zhu. “Mr. Ho here has located such a data center, have you not, Mr. Ho?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ho nodded with a grin. “I have. To be sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“And where would this great data center be located?” the chief wondered.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ho replied. “In Utah.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The chief blinked. “But . . . ,” he stammered. “You are referring to the highly secure government surveillance complex at the United States Data Center in Bluffdale, Utah?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We are,” Colliquin said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“But that is under the control of the United States government.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Presently, yes,” Colliquin agreed with the nonchalance of someone who had a plan.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A stunned look settled on the chief’s face. “But as we all know”—he stammered a bit as he said it—“the American president has refused to become part of your Global Alliance, Chancellor.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If the chief expected a response to that, Colliquin wasn’t giving one. Instead, he simply stared at the chief and with a calm voice, like an elementary school teacher, explained the next step. “Mr. Ho here has discovered something important. Isn’t that right, Mr. Ho?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ho nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Colliquin continued, “And Mr. Ho will be transmitting, directly to you, the information he is gathering on the U.S. Data Center at Bluffdale. Correct, Mr. Ho?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Certainly,” Ho agreed without emotion.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Colliquin abruptly dismissed his deputy chancellor, who turned on his heel and left. Colliquin continued his conversation with the head of his radical Internet project. “Now, about the imagery details . . .”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("The lab chief nodded energetically and talked as he led Colliquin to a separate, locked laboratory. “The cloud-networked, holograph")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("-to-human interactive digital program. Yes, of course. We’re all very excited about that. The concept is at the very frontier of technology—the idea of physically linking humans to the Internet and then using a web-based holographic image to influence neural responses in the brain.”")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("After inputting code into the trio of computers connected to the digital image laser tubes, the chief waved his hand over a few tabs on the master screen. Then he turned to Colliquin. “Where in the room would you like it?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Colliquin smiled and pointed to the space above a storage cabinet at the far end of the laboratory. “Let’s start there.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Easy enough,” the chief said. He activated the 3-D GPS locator function on the screen and touched the spot that showed an outline of the room and the cabinet. Then he pressed an icon on the screen. That was when the 3-D image of the face appeared, hovering over the cabinet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Colliquin smiled. “Make it bigger. Much bigger.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The chief tapped a tab on his screen and the hologram suddenly filled the entire room, eclipsing Colliquin and the technology chief with the giant human likeness that seemed to have a life of its own.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Colliquin grinned broadly and raised his hands in a kind of strange blessing at what he saw. He could have cried for joy, but he didn’t have the ability. Not because of some physiological defect of the tear ducts, but rather because of something else altogether—something deep inside of him that was invisible to the eye, but very dark. And it was growing unchecked with the passage of time, like a malignancy.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-371142dd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter5.vue
// module id = 81
// module chunks = 0